<template>
    <div class="ContactUs">
        <!-- 移动端返回 -->
        <div class="toReturn" @click="toReturn">
            <img src="../assets/img/nav_return.svg" />
        </div>
        <!-- 内容 -->
        <h3>联系我们</h3>
        <p class="way">有意见或者建议等其它可以用以下方式联系我们</p>
        <ul>
            <li>
                <div><img src="../assets/img/phone_icon.svg" /><span>培训联系</span></div>
                <div><span>邱剑</span><span>18019171897</span></div>
            </li>
            <li>
                <div><img src="../assets/img/book_icon.svg" /><span>课程制作技术支持</span></div>
                <div><span>钱祯鸣</span><span>13818498867</span></div>
            </li>
            <li>
                <div><img src="../assets/img/Email_icon.svg" /><span>联系邮箱</span></div>
                <p>jpzx@stec.sh.cn</p>
            </li>
            <li>
                <div><img src="../assets/img/position_icon.svg" /><span>联系地址</span></div>
                <p>徐汇区虹漕南路155号</p>
            </li>
        </ul>
        <img src="../assets/img/pc_map.png" class="pc_map" />
        <img src="../assets/img/pc_map.png" class="mobile_map" />
        <!-- 反馈 -->
        <div class="feedbackWrap">
            <p>问题反馈</p>
            <el-input
                type="textarea"
                :rows="8"
                placeholder="请说出你的想法"
                v-model="feedback">
            </el-input>
            <p class="submitBtn" @click="submitFn">提交</p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            feedback:''  // 反馈
        }
    },
    methods: {
        // 提交反馈
        submitFn(){
            if(this.feedback == '') return;

            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "Memo":this.feedback
            }
            this.$axios.post(Const_Api_Root+'api/Member/PutFeedback',data,{
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.$message({
                        message: '提交反馈成功',
                        type: 'success',
                        duration: 3000
                    });
                    this.feedback = '';
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 返回
        toReturn(){
            this.$router.push({path: '/index'});
        }
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .ContactUs{
        width: 100%;
        padding: 0 17px;
        .toReturn{
            width: 100%;
            height: 60px;
            margin-bottom: 22px;
            display: flex;
            align-items: center;
            img{
                width: 30px;
                height: 30px;
            }
        }
        .mobile_map{
            width: 100%;
            height: auto;
        }
        // pc端地图
        .pc_map{
            display: none;
        }
        h3{
            font-size: 20px;
            color: #19191A;
            text-align: center;
        }
        p{
            color: rgba(25,25,26,0.80);
            text-align: center;
        }
        .way{
            font-size: 12px;
            margin: 10px 0 35px;
        }
        ul{
            display: flex;
            flex-direction: column;
            li{
                background: #FAFAFA;
                border-radius: 8px;
                width: 100%;
                line-height: 42px;
                padding: 0 20px;
                margin-bottom: 22px;
    
                display: flex;
                justify-content: space-between;
                align-items: center;
                img{
                    width: 22px;
                    height: 22px;
                }
                div{
                    font-size: 12px;
                    span{
                        margin-left: 12px;
                    }
                    &:first-child{
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 1029px) {
    .ContactUs{
        width: 800px;
        margin: 91px auto 0;
        // 移动端地图+返回
        .mobile_map,.toReturn{
            display: none;
        }
        .pc_map{
            width: 800px;
            height: 169px;
        }
        h3{
            font-size: 30px;
            color: #19191A;
            text-align: center;
        }
        p{
            color: rgba(25,25,26,0.80);
            text-align: center;
        }
        .way{
            font-size: 14px;
            margin: 20px 0 42px;
        }
        ul{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
                background: #FAFAFA;
                border-radius: 8px;
                width: 380px;
                line-height: 42px;
                padding: 0 20px;
                margin-bottom: 40px;
    
                display: flex;
                justify-content: space-between;
                align-items: center;
                img{
                    width: 22px;
                    height: 22px;
                }
                div{
                    font-size: 12px;
                    span{
                        margin-left: 12px;
                    }
                    &:first-child{
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
}
// 公用  反馈
.feedbackWrap{
    width: 100%;
    margin-top: 40px;
    p:first-child{
        font-size: 18px;
        text-align: left;
        margin-bottom: 10px;
        color: #19191a;
    }
    .submitBtn{
        border-radius: 22px;
        font-size: 14px;
        color: #FFFFFF;
        width: 169px;
        margin: 40px auto 30px;
        line-height: 44px;
        text-align: center;
        cursor: pointer;
        background: #0061FE;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ContactUs.vue